import React from 'react';
import JudgeScoringPageRotation from './JudgeScoringPageRotation';

export default function VaultScoring() {
  return <JudgeScoringPageRotation apparatus="wagvault" />;
}
